export const formFieldNames = <const>{
    comment: 'comment',
};

export const commentMaxLength = 1024;
